import { SERVICE_TYPE } from "providers/Auth";
import { MagicLink } from "./address";

export enum FEATURES {
  FREE_CHECKOUT = "free_checkout",
  SDK = "sdk",
  DELINQUENCY_REPORTING = "delinquency_reporting",
  API_ACCESS = "api_access",
  BOOM_SCREEN = "boom_screen",
  RENT_REPORTING = "rent_reporting",
  ALLOW_MANUAL_PROPERTY_MANAGEMENT = "allow_manual_property_management"
}

export enum PropertyManagementSystem {
  APPFOLIO = "appfolio",
  BUILDIUM = "buildium",
  ENTRATA = "entrata",
  MANAGE_AMERICA = "manage_america",
  QUEXT = "quext",
  RENT_MANAGER = "rent_manager",
  RENTERS_WAREHOUSE = "renters_warehouse",
  RENTVINE = "rentvine",
  RESMAN = "resman",
  YARDI = "yardi",

  OTHER = "other"
}

type BankAccount = {
  id: number;
  account_number: string;
  routing_number: string;
  account_nickname: string;
  account_subtype: "checking" | "savings";
  default: boolean;
  name: string;
  last4?: string;
};

export type Partner = {
  name: string;
  url?: string;
  logo_url: string | null;
  algolia: {
    client_search_key?: string;
    index_name?: string;
  } | null;
  features: FEATURES[];
  service_type?: SERVICE_TYPE;
  property_management_system?: {
    name: PropertyManagementSystem | "";
    last_synced_at: string | null;
  };
  magic_link?: MagicLink;
  invoice_billing_day: number;
  payout_billing_day: number;
  payout_bank_account: BankAccount;
  invoice_bank_account: BankAccount;
  opt_out_period_days: number;
  opt_in_period_days: number;
  unexpired_opt_in_period: boolean;
  notification_settings: {
    application_started: boolean;
    application_submitted: boolean;
  };
};
